import React from 'react'
import '../styles/footer.css'

const Footer = () => {
    return (
        <div className="mt-5">
            <div style={{ backgroundColor: "#f2d9d8" }}>
                <div className="text-center p-2">
                    <a style={{ color: "black", textDecoration: "none" }} href="#">&copy; 2020 Bartłomiej Waszak</a>
                </div>
            </div>
        </div>
    );
}

export default Footer;
